<template>
  <div class='content-wrapper'>
    <div class="notfound-panel">
      <p>404: Page is not found</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.content-wrapper {
  margin: 25px 20px 50px 20px;
  padding: 20px;
  /*overflow: hidden;*/
  background: #D9E0E7;
}
.notfound-panel {
  margin-top: 40px;
  font-family: "Lato Thin", sans-serif;
  font-size: 40px;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// 404PageNotFound.vue?763f6b25